<div
  class="wrapper" [ngClass]="{'wrapper': !isComplete, 'wrapperPopup': isComplete}"
  [style.top.px]="position && !isComplete ? -position.top + 50 : 0"
  [style.width]="position && !isComplete ? 'none' : '100%'"
  >
  <div class="leftSide">
    <div class="titleContainer">
      <div class="title">
        <gl-icon class="multistopIcon" name="multistop"></gl-icon>
        {{ 'points_along_route' | translate }}
      </div>

      @if (!isComplete) {
        <button outline-icon-button class="button" (click)="close()">
          <gl-icon class="closeIcon" name="close"></gl-icon>
        </button>
      }
    </div>

    <div class="formContainer">
      <form [formGroup]="form" (ngSubmit)="submit()" class="form">
        <div [ngClass]="{'completeHeight': isComplete}">
          @for (control of form.controls | keyvalue; track control; let i = $index) {
            <div class="row">
              <gl-input-container
                class="inputContainer name" [ngClass]="{'complete': isComplete}"
                >
                <input
                  type="text"
                  [placeholder]="
              i === 0
                ? translateInstant('name_multistop_start') + ' (' + toCharacter(i + 10) + ')'
                : objectKeys(form.controls).length === i + 1
                ? translateInstant('name_multistop_end') + ' (' + toCharacter(i + 10) + ')'
                : translateInstant('name_multistop_middle') + ' (' + toCharacter(i + 10) + ')'
            "
                  normal-input
                  [formControlName]="control.key"
                  />
                <div class="edit" data-ctx="deletePointButton">
                  @if (!isComplete) {
                    @if (i !== 0 && objectKeys(form.controls).length > 3) {
                      <button
                        outline-icon-button
                        class="button"
                        (click)="deletePoint(control.key)"
                        >
                        <gl-icon class="closeIcon" name="close"></gl-icon>
                      </button>
                    }
                  }
                </div>
              </gl-input-container>
              @if (!isAddressOn(control.key)) {
                <button
                  outline-icon-button
                  type="button"
                  data-ctx="addressButton"
                  class="button addressButton"
                  (click)="turnOnAddress(control.key)"
                  >
                  <gl-icon class="locationIcon" name="locationIco"></gl-icon>
                </button>
              }
              @if (isAddressOn(control.key)) {
                <gl-select
                  class="inputContainer select"
                  placeholder="country"
                  [formControl]="getAddressForm(control.key, 'country')"
                  [searchOption]="true"
                  (searchEmit)="onSearch($event)"
                  >
                  @for (country of countries; track country) {
                    <gl-option [value]="country" [label]="country">
                    </gl-option>
                  }
                </gl-select>
              }
              @if (isAddressOn(control.key)) {
                <gl-input-container
                  class="inputContainer address"
                  >
                  <input
                    type="text"
                    [placeholder]="translateInstant('city')"
                    normal-input
                    [formControl]="getAddressForm(control.key, 'city')"
                    />
                </gl-input-container>
              }
              @if (isAddressOn(control.key)) {
                <gl-input-container
                  class="inputContainer address short"
                  >
                  <input
                    type="text"
                    [placeholder]="translateInstant('postal_code')"
                    normal-input
                    [formControl]="getAddressForm(control.key, 'postalCode')"
                    />
                </gl-input-container>
              }
              @if (isAddressOn(control.key)) {
                <gl-input-container
                  class="inputContainer address"
                  >
                  <input
                    type="text"
                    [placeholder]="translateInstant('street_address')"
                    normal-input
                    [formControl]="getAddressForm(control.key, 'street')"
                    />
                </gl-input-container>
              }
            </div>
          }
          <div class="buttonRow" [ngClass]="{'right': isComplete}">
            @if (!isComplete) {
              <button data-ctx="addAnotherPointButton" submit-button type="button" (click)="addAnotherPoint()">
                <gl-icon class="anotherPointIcon" name="anotherPoint"></gl-icon>
                {{ 'add_another_point' | translate }}
              </button>
              <!--              <gl-checkbox-->
              <!--                class="eMapa"-->
              <!--                [ngModel]="eMapa"-->
              <!--                [ngModelOptions]="{ standalone: true }"-->
              <!--                (ngModelChange)="onEmapa()"-->
              <!--              >{{ 'e_mapa' | translate }}-->
              <!--              </gl-checkbox
              >-->
            }
            <button id="SubmitButton" submit-button type="submit">{{ (!isComplete ? 'save' : 'send') | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
